const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText } = require('core/i18n').i18n;
const { findActiveFilters } = require('utilities/filtersHelper');
const { EmptyState } = require('commonsComponents/emptyState');
// @ components
const ReceivedTransfersContentHeader = require('./receivedTransfersContentHeader/receivedTransfersContentHeader');
const ReceivedTransfersContentTable = require('./receivedTransfersContentTable/receivedTransfersContentTable');
const ReceivedTransfersContentFilters = require('./receivedTransfersContentFilters/receivedTransfersContentFilters');
const { LoadingSection } = require('commonsComponents/loadingSection');

class ReceivedTransfersContent extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {
            immReceivedTransfers,
            immAccount,
            immAccounts,
            immFilter,
            immScreen,
            onFilterClick,
            onResetFilter,
            onClearFilters,
            requestReceivedTransfersNextPage
            } = this.props;
        const accountId = immAccount.get('accountId');
        const immAccountReceivedTransfers = immReceivedTransfers.get(accountId);
        const hasFilters = findActiveFilters(immFilter);
        let filters;
        let content;

        if (hasFilters) {
            filters = (
                <ReceivedTransfersContentFilters
                    immFilter={immFilter}
                    onResetFilter={onResetFilter}
                    onClearFilters={onClearFilters}
                />
            );
        }

        if (immAccountReceivedTransfers && immAccountReceivedTransfers.get('byOrder').size > 0) {
            content = (
                <ReceivedTransfersContentTable
                    immAccountReceivedTransfers={immAccountReceivedTransfers}
                    accountId={accountId}
                    immScreen={immScreen}
                    requestReceivedTransfersNextPage={requestReceivedTransfersNextPage}
                />
            );
        } else {
            if (hasFilters) {
                content = <EmptyState primaryText={formatText('transfersReceived-hasFilterNoTransfersRetrieved')} iconType="transfer-banking"/>;
            } else {
                content = (
                    <EmptyState
                        primaryText={formatText('transfersLanding-noReceivedTransfers')}
                        iconType="transfer-banking" />
                );
            }
        }

        if (immAccountReceivedTransfers && immAccountReceivedTransfers.get('loading')){
           content = (<LoadingSection />);
        }

        return (
            <article className="received-transfers-content">
                <ReceivedTransfersContentHeader
                    accountId={accountId}
                    immAccounts={immAccounts}
                    immFilter={immFilter}
                    onFilterClick={onFilterClick}
                />
                {filters}
                {content}
            </article>
        );
    }
}

ReceivedTransfersContent.propTypes = {
    immReceivedTransfers: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFilter: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onResetFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    requestReceivedTransfersNextPage: PropTypes.func.isRequired
}

module.exports = ReceivedTransfersContent;